module.exports = __webpack_public_path__ + "img/PLC-3.a036dd02.png";